
const HandleLogOut = () => {
    localStorage.removeItem('Token')
    // localStorage.removeItem('liber-wishlist')
    // localStorage.removeItem('liber-cartlist')
    // localStorage.removeItem('Token')

    return;
};

export default HandleLogOut;